import {auth} from '../firebase';
import {Logger} from '../plugins/logger';

const log = Logger.get('auth');

export default {
  namespaced: true,
  state: {
    authUser: {},
    authUserNotified: false,
  },
  getters: {
    uid(state) {
      return state.authUser.email;
    },
    email(state) {
      return state.authUser.email;
    },
    authLoaded(state) {
      return state.authUserNotified;
    },
    isAuthenticated(state) {
      return Object.keys(state.authUser).length !== 0;
    }
  },
  mutations: {
    updateAuthUser(state, authUser) {
      state.authUser = authUser ? authUser : {};
    },
    setAuthUser(state, authUser) {
      state.authUser = authUser ? authUser : {};
    },
    setAuthUserNotified(state) {
      state.authUserNotified = true;
    }
  },
  actions: {
    bind({commit}) {
      log.info('bind');
      auth.onAuthStateChanged(user => {
        log.info('onAuthStateChanged', user);
        // only store the properties we use, this may help with Vue dev tools issues
        commit('setAuthUser', user === null ? {} : {
          uid: user.uid,
          email: user.email
        });
        commit('setAuthUserNotified');
      }, err => {
        log.error('onAuthStateChanged', err);
      }, () => {
        log.info('onAuthStateChanged completed');
      });

      auth.getRedirectResult().catch(error => {
        log.error('getRedirectResult', error);
      });
    },
  }
};
